import { useState } from 'react';
import backgroundImage from '../assets/portada.heic';

export default function Hero() {
  const [nombre, setNombre] = useState('');
  const [vehiculo, setVehiculo] = useState('');
  const [consulta, setConsulta] = useState('');

  const mensajeWhatsApp = `Hola, soy ${nombre}, tengo un ${vehiculo} y me gustaría consultar lo siguiente: ${consulta}`;

  const enviarConsulta = () => {
    const url = `https://wa.me/5493517396347?text=${encodeURIComponent(mensajeWhatsApp)}`;
    window.open(url, '_blank');

    // Limpiar los campos después de abrir WhatsApp
    setNombre('');
    setVehiculo('');
    setConsulta('');
  };

  return (
    <section
      className="hero"
      style={{
        background: `url(${backgroundImage}) center center / cover no-repeat`,
      }}
    >
      <img src="/imagenes/logo.webp" alt="Logo" className="hero-logo" />

      {/* Formulario visible solo en PC */}
      <div className="formulario-wsp">
        <h3>Hacé tu consulta</h3>
        <input
          type="text"
          placeholder="Tu nombre"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
        />
        <input
          type="text"
          placeholder="Vehículo"
          value={vehiculo}
          onChange={(e) => setVehiculo(e.target.value)}
        />
        <textarea
          placeholder="Consulta..."
          value={consulta}
          onChange={(e) => setConsulta(e.target.value)}
        />
        <button onClick={enviarConsulta}>Enviar por WhatsApp</button>
      </div>

      {/* Botón clásico del Hero, visible solo en mobile */}
      <div className="btn-wsp-hero">
        <a
          href="https://wa.me/5493517396347"
          className="btn-wsp animado"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-whatsapp"></i> WhatsApp
        </a>
      </div>
    </section>
  );
}
